export const GOLD = "#E2DD9F";

export const DARK = {
  bg:"#0A0A0A", bgCard:"#111111", bgHover:"#1A1A1A",
  bgElevated:"#171717",
  border:"rgba(255,255,255,0.06)", gold:GOLD, goldDim:"rgba(226,221,159,0.10)",
  goldHover:"#F5F0B8",
  text:"#F5F5F5", textMid:"#9CA3AF", textDim:"#555",
  inputBg:"#0E0E0E",
  green:"#5AB584", greenDim:"rgba(90,181,132,0.14)",
  blue:"#7AABCF", blueDim:"rgba(122,171,207,0.14)",
  shadow:"rgba(0,0,0,0.6)",
  cardGradient:"linear-gradient(180deg,#131313 0%,#0C0C0C 100%)",
  cardBorder:"rgba(255,255,255,0.05)",
  cardHoverBorder:"rgba(226,221,159,0.35)",
  innerGlow:"inset 0 1px 0 0 rgba(255,255,255,0.04)",
  surfaceShadow:"0 4px 24px rgba(0,0,0,0.35), 0 1px 2px rgba(0,0,0,0.25)",
  elevatedShadow:"0 8px 32px rgba(0,0,0,0.45), 0 2px 4px rgba(0,0,0,0.3)",
};

export const LIGHT = {
  bg:"#FFFFFF", bgCard:"#FFFFFF", bgHover:"#F5F5F5",
  bgElevated:"#FAFAFA",
  border:"#E8E8E8", gold:GOLD, goldDim:"rgba(226,221,159,0.4)",
  goldHover:"#F5F0B8",
  text:"#111111", textMid:"#444444", textDim:"#666666",
  inputBg:"#F5F5F5",
  green:"#2D7A50", greenDim:"rgba(45,122,80,0.10)",
  blue:"#2A527A", blueDim:"rgba(42,82,122,0.10)",
  shadow:"rgba(0,0,0,0.07)",
  cardGradient:"linear-gradient(180deg,#FFFFFF 0%,#FAFAFA 100%)",
  cardBorder:"#E8E8E8",
  cardHoverBorder:"rgba(226,221,159,0.5)",
  innerGlow:"inset 0 1px 0 0 rgba(255,255,255,0.8)",
  surfaceShadow:"0 2px 8px rgba(0,0,0,0.06)",
  elevatedShadow:"0 4px 16px rgba(0,0,0,0.1)",
};

export const SBcard = "#0E0E0E";
export const SBborder = "rgba(255,255,255,0.06)";
export const SBtext = "#F5F5F5";
export const SBmid = "#9CA3AF";
export const SBdim = "#555";

export const AVATAR_COLORS = ["#5B7FA6","#6B9E7A","#9E6B7A","#9E8A5B","#7A6B9E","#5B9E8A","#9E7A5B","#6B7A9E"];
export const getAC = (n) => AVATAR_COLORS[n.charCodeAt(0) % AVATAR_COLORS.length];

export const CARD_BORDERS = ["#E2DD9F","#555555","#C8C090","rgba(255,255,255,0.08)","#A8A070"];
export const getCardBorder = (id) => CARD_BORDERS[id % CARD_BORDERS.length];
